jQuery(document).ready(function ($) {
    const themeStorageKey = 'zggtheme-color-scheme';
    const $documentElement = $('html');
    const $darkModeToggleLink = $('.dark-mode-toggle a');
    const prefersDarkQuery = (() => {
        try {
            return window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
        } catch (error) {
            return null;
        }
    })();

    const isRecognizedTheme = (theme) => theme === 'dark' || theme === 'light';

    const setThemeCookie = (theme) => {
        try {
            if (isRecognizedTheme(theme)) {
                document.cookie = `${themeStorageKey}=${theme};path=/;max-age=${60 * 60 * 24 * 365};SameSite=Lax`;
            } else {
                document.cookie = `${themeStorageKey}=;path=/;max-age=0;SameSite=Lax`;
            }
        } catch (error) {
            // ignore cookie write errors
        }
    };

    const readThemeCookie = () => {
        try {
            const match = document.cookie.match(new RegExp(`(?:^|; )${themeStorageKey}=([^;]*)`));
            return match ? decodeURIComponent(match[1]) : null;
        } catch (error) {
            return null;
        }
    };

    const getStoredTheme = () => {
        const storedTheme = readThemeCookie();
        return isRecognizedTheme(storedTheme) ? storedTheme : null;
    };

    const clearThemeCookie = () => {
        setThemeCookie(null);
    };

    const getSystemTheme = () => {
        if (!prefersDarkQuery) {
            return null;
        }

        try {
            return prefersDarkQuery.matches ? 'dark' : 'light';
        } catch (error) {
            return null;
        }
    };

    const updateToggleAccessibility = (theme) => {
        if ($darkModeToggleLink.length) {
            const isDark = theme === 'dark';
            $darkModeToggleLink.attr('aria-pressed', isDark ? 'true' : 'false');
        }
    };

    const reconcileStoredPreferenceWithSystem = () => {
        const systemTheme = getSystemTheme();

        if (!systemTheme) {
            return;
        }

        const storedTheme = getStoredTheme();

        if (!storedTheme || storedTheme !== systemTheme) {
            return;
        }

        const currentTheme = $documentElement.attr('data-theme');

        if (!currentTheme || currentTheme === systemTheme) {
            clearThemeCookie();
        }
    };

    const applyTheme = (theme, options = {}) => {
        const persist = options.persist !== false;
        const skipConvergenceCheck = options.skipConvergenceCheck === true;

        if (isRecognizedTheme(theme)) {
            $documentElement.attr('data-theme', theme);
            if (persist) {
                setThemeCookie(theme);
            }
            updateToggleAccessibility(theme);
        } else {
            $documentElement.removeAttr('data-theme');
            if (persist) {
                setThemeCookie(null);
            }
            updateToggleAccessibility(null);
        }

        if (!skipConvergenceCheck) {
            reconcileStoredPreferenceWithSystem();
        }
    };

    const syncSystemPreference = (event) => {
        if (!prefersDarkQuery) {
            return;
        }

        const matches = typeof event.matches === 'boolean' ? event.matches : prefersDarkQuery.matches;
        const systemTheme = matches ? 'dark' : 'light';
        const storedTheme = getStoredTheme();

        if (storedTheme) {
            if (storedTheme === systemTheme) {
                clearThemeCookie();
                applyTheme(systemTheme, { persist: false, skipConvergenceCheck: true });
            }

            return;
        }

        applyTheme(systemTheme, { persist: false, skipConvergenceCheck: true });
    };

    const initialTheme = getStoredTheme();
    const domTheme = $documentElement.attr('data-theme');

    if (initialTheme) {
        applyTheme(initialTheme);
    } else if (isRecognizedTheme(domTheme)) {
        updateToggleAccessibility(domTheme);
        reconcileStoredPreferenceWithSystem();
    } else if (prefersDarkQuery) {
        syncSystemPreference(prefersDarkQuery);
    } else {
        updateToggleAccessibility(null);
    }

    if (prefersDarkQuery) {
        if (typeof prefersDarkQuery.addEventListener === 'function') {
            prefersDarkQuery.addEventListener('change', syncSystemPreference);
        } else if (typeof prefersDarkQuery.addListener === 'function') {
            prefersDarkQuery.addListener(syncSystemPreference);
        }
    }

    if ($darkModeToggleLink.length) {
        const linkLabel = $darkModeToggleLink.text().trim();

        if (linkLabel.length) {
            $darkModeToggleLink.attr('aria-label', linkLabel);
            $darkModeToggleLink.attr('title', linkLabel);
        }

        $darkModeToggleLink.on('click', function (event) {
            event.preventDefault();

            const currentTheme = $documentElement.attr('data-theme');
            const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';

            applyTheme(nextTheme);
        });
    }

    $('.navbar-toggler').each(function () {

        const $headerNav = $('.menu-header-container')

        const handleClickToggler = function (event) {
            event.stopPropagation();

            $headerNav.toggleClass('show');
        };

        $(this)
            .on('click', handleClickToggler)
    })

    $('.menu-item-has-children > a').each(function () {

        const $subMenu = $(this).parent().find(".sub-menu")

        const handleTouchParentNav = function (event) {
            event.stopPropagation()

            $('.sub-menu.show').not($subMenu).removeClass('show')

            //toggle: adds show if not there and remove when there
            $subMenu.toggleClass('show')

            if (window.innerWidth >= 768 || $(this).parent().hasClass('wpml-ls-menu-item')) {
                event.preventDefault()
            }
        };

        $(this)
            .on('click', handleTouchParentNav)
        //.on('touchend', handleTouchParentNav)
    })

    $(document).on('click', function (event) {
        const $target = $(event.target);

        // Prüfen, ob der Klick außerhalb des Menüs und des Togglers erfolgt ist
        if (!$target.closest('.menu-item-has-children > a').length && !$target.closest('.navbar-toggler').length) {
            $('.menu-header-container').removeClass('show');
            $('.sub-menu.show').removeClass('show');
        }
    });


    $('.dropdown-item, .nav-link').each(function () {
            const currentURL = window.location.href
            const wordToCheck = $(this).text().toLowerCase().trim().replace(/[äöüß ]/g, function (ch) {
                if ("ä" === ch) {
                    return 'ae';
                } else if ("ü" === ch) { // There are a lot more than this
                    return 'ue';
                } else if ("ö" === ch) { // There are a lot more than this
                    return 'oe';
                } else if ("ß" === ch) { // There are a lot more than this
                    return 'ss';
                }

                return '-';
            });

            if (currentURL.indexOf(wordToCheck) !== -1) {
                $(this).addClass('currently-on')
                //console.log(this)
            }
        }
    )
})
